import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {ReasonService} from '../../../shared/services/reason.service';

@Component({
    selector: 'app-add-reason',
    templateUrl: './add-reason.component.html',
    styleUrls: ['./add-reason.component.scss']
})
export class AddReasonComponent implements OnChanges {
    addReasonForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                private reasonService: ReasonService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-reason').toggleOpen();
    }

    refresh() {
        this.addReasonForm = this.fb.group({
            'name': ['', Validators.required],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addReasonForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addReasonForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addReasonForm.value && this.addReasonForm.value.name) ? this.addReasonForm.value.name : '',
            };
            this.submitting = true;
            this.reasonService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addReasonForm.reset();
                    this.addReasonForm.patchValue({
                        'name': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addReasonForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addReasonForm.value && this.addReasonForm.value.name) ? this.addReasonForm.value.name : '',
            };
            this.submitting = true;
            this.reasonService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }
}
